import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import MainDashboardLayout from './layouts/MainDashboardLayout';
import NotFoundPage from './pages/error/NotFoundPage';
import HomePage from './pages/main-dashboard-pages/home-pages/HomePage';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SidebarProvider } from './contexts/SidebarContext';
import { useContext } from 'react';
import ResourcePage from './pages/landing-layout-pages/ResourcePage';
import LandingLayout from './layouts/LandingLayout';
//import KnowledgeSummary from "./pages/main-dashboard-pages/knowledge-pages/KnowledgeSummary";
import QuestionReview from './pages/main-dashboard-pages/questions-pages/QuestionReview.js';
//import QuestionThreads from './pages/main-dashboard-pages/questions-pages/QuestionThreads.js';
// import QuestionFixed from "./pages/main-dashboard-pages/questions-pages/QuestionFixed.js"
import KnowledgeTutor from "./pages/main-dashboard-pages/knowledge-pages/KnowledgeTutor.js"
import MockExams from "./pages/main-dashboard-pages/questions-pages/QuestionMockExams.js"
import Questionbank from "./pages/main-dashboard-pages/questions-pages/Questionbank.js"
import StarterQuestion from './pages/main-dashboard-pages/questions-pages/StarterQuestion.js';
import KnowledgeSummary from './pages/main-dashboard-pages/knowledge-pages/KnowledgeSummary.js';
import KnowledgeReview from './pages/main-dashboard-pages/knowledge-pages/KnowledgeReview.js';
import KnowledgeCatergory from './pages/main-dashboard-pages/knowledge-pages/KnowledgeCatergory.js';
import QuestionAnalysis from './pages/main-dashboard-pages/questions-pages/perfomances/QuestionAnalysis.js';
// import QuestionFixed from './pages/main-dashboard-pages/questions-pages/QuestionFixed.js';
import QuestionOverTime from './pages/main-dashboard-pages/questions-pages/perfomances/QuestionOverTime.js';
import QuestionSummary from './pages/main-dashboard-pages/questions-pages/perfomances/QuestionSummary.js';
import QuestionCatergory from './pages/main-dashboard-pages/questions-pages/perfomances/QuestionCatergory.js';
import QuestionHeatMap from './pages/main-dashboard-pages/questions-pages/perfomances/QuestionHeatMap.js';
import QuestionMockExams from './pages/main-dashboard-pages/questions-pages/QuestionMockExams.js';
import QuestionFixed from './pages/main-dashboard-pages/questions-pages/QuestionFixed.js';
import MockExamLanding from './pages/main-dashboard-pages/questions-pages/exams-pages/MockExamLanding.js';
import MockExamInstructions from './pages/main-dashboard-pages/questions-pages/exams-pages/MockExamInstructions.js';
import MockExamQuestions from './pages/main-dashboard-pages/questions-pages/exams-pages/MockExamQuestions.js';
import MockExamResultPage from './pages/main-dashboard-pages/questions-pages/exams-pages/MockExamResultPage.js';
import LandingHomePage from './pages/landing-layout-pages/LandingHomePage.js';
import ContactPage from "./pages/landing-layout-pages/ContactPage.js"
import WorkWithUsPage from "./pages/landing-layout-pages/WorkWithUsPage.js"
import KnowledgeExam from "./pages/main-dashboard-pages/knowledge-pages/knowledge-exam/KnowledgeExam.js"
import TextBook from './pages/main-dashboard-pages/texbook-pages/TextBook.js';
import AlreadySubscribed from './pages/main-dashboard-pages/user-sidebar-pages/AlreadySubscribed.js';
import CancelPage from './pages/main-dashboard-pages/user-sidebar-pages/CancelPage.js';
import Subscribe from './pages/main-dashboard-pages/user-sidebar-pages/Subscribe.js';
import Faq from './pages/main-dashboard-pages/user-sidebar-pages/Faq.js';
import Contact from './pages/main-dashboard-pages/user-sidebar-pages/Contact.js';
import SignUp from './pages/landing-layout-pages/SignUp.js';
import Login from './pages/landing-layout-pages/Login.js';
import { UserProvider } from './contexts/UserContext.js';
import ProtectedRoute from './utils/ProtectedRoute';
import PublicRoute from './utils/PublicRoute';


function App() {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

  return (
      <Router>
          <UserProvider>
              <SidebarProvider>
                  <Routes>
                      {/* Public Routes */}
                      <Route element={<PublicRoute />}>
                          <Route path="/" element={<LandingLayout />}>
                              <Route index element={<LandingHomePage />} />
                              <Route path="landinghomepage" element={<LandingHomePage />} />
                              <Route path="contactpage" element={<ContactPage />} />
                              <Route path="workwithuspage" element={<WorkWithUsPage />} />
                              <Route path="signup" element={<SignUp />} />
                              <Route path="login" element={<Login />} />
                          </Route>
                      </Route>

                      {/* Protected Routes for Students */}
                      <Route element={<ProtectedRoute allowedRoles={['Student']} />}>
                          <Route path="/dashboard" element={<MainDashboardLayout />}>
                              <Route index element={<HomePage />} />
                              <Route path="home" element={<HomePage />} />
                              <Route path="question-questionbank" element={<Questionbank />} />
                              <Route path="question-mockexam" element={<QuestionMockExams />} />
                              <Route path="question-fixed" element={<QuestionFixed />} />
                              <Route path="question-review" element={<QuestionReview />} />
                              <Route path="question-summary" element={<QuestionSummary />} />
                              <Route path="question-category" element={<QuestionCatergory />} />
                              <Route path="question-overview" element={<QuestionOverTime />} />
                              <Route path="question-heatmap" element={<QuestionHeatMap />} />
                              <Route path="question-analysis" element={<QuestionAnalysis />} />

                              <Route path="knowledge" element={<KnowledgeTutor />} />
                              <Route path="knowledge-category" element={<KnowledgeCatergory />} />
                              <Route path="knowledge-summary" element={<KnowledgeSummary />} />
                              <Route path="knowledge-review" element={<KnowledgeReview />} />
                              <Route path="textbook" element={<TextBook />} />

                              <Route path="alreadysubscribed" element={<AlreadySubscribed />} />
                              <Route path="cancelpage" element={<CancelPage />} />
                              <Route path="subscribe" element={<Subscribe />} />
                              <Route path="faq" element={<Faq />} />
                              <Route path="contact" element={<Contact />} />
                          </Route>

                          {/* Protected routes outside dashboard layout */}
                          <Route path="/knowledgeexam" element={<KnowledgeExam />} />
                          <Route path="/starter-question" element={<StarterQuestion />} />
                          <Route path="/mock-exam-instruction" element={<MockExamInstructions />} />
                          <Route path="/mock-exam-questions" element={<MockExamQuestions />} />
                          <Route path="/exam-results" element={<MockExamResultPage />} />
                      </Route>

                      {/* Optional: 404 Not Found Route */}
                      {/* <Route path="*" element={<NotFoundPage />} /> */}
                  </Routes>
              </SidebarProvider>
          </UserProvider>
      </Router>
  );
}


export default App;
